import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import NotaryProductPage from "@/components/NotaryProductPage";
import { notaryProductGraph, defaultNotaryProductFaqs } from "@/lib/notary-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/en/notary/products/$slug")({
  loader: async ({ params }) => {
    const { getNotaryProduct } = await import("@/data/notary-products");
    const p = getNotaryProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("Not found", "/en/notary/products/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/en/notary/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `${p.nameEn} — Thai Notarial Services | ${p.act.turnaround}`;
    const desc = p.shortDescEn + " · Thai-Bar-registered Notarial Services Attorney — ready for MFA / Apostille / embassy chain.";
    const faqs = defaultNotaryProductFaqs(p, "en");
    return {
      meta: [
        { title: ctaTitle(title, "/en/notary/products/$slug", "en") }, { name: "description", content: ctaDesc(desc, "/en/notary/products/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/notary/products/$slug", "en")},
        { property: "og:description", content: ctaDesc(desc, "/en/notary/products/$slug", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "en_US" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${BRAND_URL}/notary/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: `${BRAND_URL}/notary/products/${params.slug}` },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(notaryProductGraph({ product: p, locale: "en", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">Service not found</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <NotaryProductPage product={product} locale="en" faqs={defaultNotaryProductFaqs(product, "en")} />;
  },
});
